module.exports = __webpack_public_path__ + "img/videoMute.f99152da.svg";